import LOGO from "../assets/logo.js";
export default function Logo({ size="md", white=false, className="" }) {
  const h = { sm:"28px", md:"36px", lg:"48px", xl:"64px" }[size];
  const f = { sm:"17px", md:"20px", lg:"24px", xl:"30px" }[size];
  return (
    <div className={className} style={{ display:"flex", alignItems:"center", gap:"8px" }}>
      <img src={LOGO} alt="Returnob" style={{ height:h, width:"auto", borderRadius:"10px" }} />
      <span style={{ fontFamily:"'Playfair Display',serif", fontWeight:700,
        fontSize:f, color:white?"#fff":"#0A1F3D" }}>Returnob</span>
    </div>
  );
}
